module.exports = __webpack_public_path__ + "img/cad.a9081763.svg";